<template>
  <o-table :title="$t('medtastic.workshops')" :customDelete="true" url="/api/medtastic/workshops" ref="tableList">
    <template slot="filter">
      <div class="d-flex">
        <div>
          <o-filter :default-filter="defaultFilter"
                    v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
            <o-filter-select :items="dateStatus" :title="$t('medtastic.hide_past_workshops')"
                             column="hide_past_workshops"/>
          </o-filter>
        </div>
        <div class="ml-auto">
          <b-btn @click.prevent="xlsx()" variant="primary">
            <fa icon="file-excel"/>
            {{ $t('medtastic.export') }}
          </b-btn>
        </div>
      </div>
    </template>
    <template slot="head">
      <o-table-header column="title">{{ $t('core.title') }}</o-table-header>
      <o-table-header column="location">{{ $t('medtastic.location') }}</o-table-header>
      <o-table-header column="date">{{ $t('core.date') }}</o-table-header>
      <o-table-header column="time">{{ $t('medtastic.time') }}</o-table-header>
      <o-table-header column="time">{{ $t('medtastic.end_time') }}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.title }}</td>
      <td v-html="props.item.location"></td>
      <td>{{ props.item.date | formatDate }}</td>
      <td>{{ props.item.time | formatTimeString }}</td>
      <td>{{ props.item.end_time | formatTimeString }}</td>
    </template>
  </o-table>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
  data () {
    return {
      dateStatus: [],
      defaultFilter: []
    }
  },
  created () {
    this.dateStatus = [
      { value: 'yes', text: this.$i18n.t('core.yes') }
    ]

    this.defaultFilter = [{
      column: 'hide_past_workshops',
      displayValue: this.$i18n.t('core.yes'),
      title: this.$i18n.t('medtastic.hide_past_workshops'),
      value: 'yes'
    }]
  },
  methods: {
    xlsx () {
      axios.get(`/api/medtastic/workshops/export`, {
        paramsSerializer: qs.stringify,
        params: this.$refs.tableList.currentFilter(),
        responseType: 'arraybuffer'
      })
          .then((response) => {
            require('downloadjs')(response.data,
                'workshops' + new Date().toISOString().slice(0, 10) + '.xlsx', 'application/vnd.ms-excel'
            )
          }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>
